import { Box } from '@mui/material';

import { DropdownListItem } from './types';
import Icon from '../Icon/Icon';

export const getDropdownItemDisplayValue = (option: DropdownListItem) =>
  option?.displayValue?.toString?.() || option?.value || '';

export const getDropdownItemIcon = (option: DropdownListItem, iconSize = 16, iconId?: string) => {
  if (option.icon) {
    const id = iconId
      ? `${option.icon}-${getDropdownItemDisplayValue(option)}--${iconId}`
      : option.value;
    return <Icon id={id} icon={option.icon} height={iconSize} width={iconSize} />;
  }

  return null;
};

export const getLabelWithIcon = (
  option: DropdownListItem,
  config?: { gap?: number; iconSize?: number; showIcon?: boolean; iconId?: string }
) => {
  const { gap = 1, iconSize = 20, showIcon = false, iconId } = config || {};
  const icon = getDropdownItemIcon(option, iconSize, iconId);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }} gap={gap}>
      {showIcon ? icon : null}
      {getDropdownItemDisplayValue(option)}
    </Box>
  );
};
